
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"fill":"#FFF","width":"100pt","height":"100pt","viewBox":"0 0 100 100","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M74.172 63.535L67.395 52.57l-6.254 7.523-17.684-43.73L29.422 53l-9.852-6.433L4.246 83.633l91.512.004-16.812-25.352zm-13.695.832l6.656-8.004 1.453 2.352-7.39 10.25-4.465-13.86zM28.61 55.121l-.973 2.531-3.675-5.566zM7.571 81.41l12.742-30.82 6.348 9.617-1.828 4.77 2.074.793 16.605-43.344 1.765 4.363 15.148 47.039 9.422-13.07 3.985 6.45 4.836-5.321L91.613 81.41z"}})])
          )
        }
      }
    